import { render, staticRenderFns } from "./DialogPayment.vue?vue&type=template&id=4d561381&scoped=true&"
import script from "./DialogPayment.vue?vue&type=script&lang=js&"
export * from "./DialogPayment.vue?vue&type=script&lang=js&"
import style0 from "./DialogPayment.vue?vue&type=style&index=0&id=4d561381&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d561381",
  null
  
)

export default component.exports